import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { FirstRunGuard } from '../core/guards/first-run.guard';
import { UserActivityResolver } from '../core/resolvers/user-activity.resolver';
import { MyOrganisationResolver } from '../core/resolvers/my-organisation.resolver';
import { PermissionsGuard } from '../core/guards/permissions.guard';

export const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.routes').then((m) => m.routes),
    canActivate: [AuthGuard, PermissionsGuard],
    data: {
      requiredPermission: 'admin',
    },
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.routes),
  },
  {
    path: 'documentatie',
    loadChildren: () => import('./documentation/documentation.routes').then((m) => m.routes),
  },
  {
    path: '',
    loadChildren: () => import('./landing/landing.routes').then((m) => m.routes),
  },
  {
    path: '',
    resolve: [UserActivityResolver, MyOrganisationResolver],
    children: [
      {
        path: 'veilig-graven',
        loadChildren: () => import('./veilig-graven/veilig-graven.routes').then((m) => m.routes),
        canActivate: [AuthGuard, PermissionsGuard],
        data: {
          requiredPermission: 'veilig-graven:overview',
        },
      },
      {
        path: 'bestellen',
        loadChildren: () => import('./shop/shop.routes').then((m) => m.routes),
        canActivate: [AuthGuard, FirstRunGuard],
      },
      {
        path: 'profile',
        loadChildren: () => import('./profile/profile.routes').then((m) => m.routes),
        canActivate: [AuthGuard],
      },
      {
        path: 'projects',
        loadChildren: () => import('./projects/projects.routes').then((m) => m.routes),
        canActivate: [AuthGuard],
      },
      {
        path: 'klic',
        loadChildren: () => import('./klic/klic.routes').then((m) => m.routes),
        canActivate: [AuthGuard],
      },
      {
        path: 'export',
        loadChildren: () => import('./export/export.routes').then((m) => m.routes),
        canActivate: [AuthGuard],
      },
    ],
  },
];
